module.exports = __webpack_public_path__ + "img/itx-file-type-doc.8a463d33.svg";